import { Theme } from '@emotion/react';

export const theme: Theme = {
  colors: {
    SurfaceIndependence40: '#2D2D47',
    SurfaceCultured10: '#F4F4F5',
    SurfacePlatinum20: '#EAEAEC',
    SurfaceRomanSilver30: '#8F8E99',
    SurfaceRaisinBlack50: '#1A1A29',
    SurfaceRichBlack60: '#0A0A0B',
    SurfaceWhite: '#FFFFFF',
    SurfaceSpaceCadet50: '#23233B',

    CaseError: '#FF7061',
    CaseCorrect: '#57CD9C',

    AccentNaplesYellow: '#D9B244',
    AccentMediumChampagne: '#FAECAB',
    AccentJonquil: '#F2CA18',
    AccentCornsilk: '#FFF8D9',

    DarkYellow: '#D9B244',
    DarkYellowAlpha80: '#D9B244CC',
    DarkYellowAlpha60: '#D9B24499',
    DarkYellowAlpha40: '#D9B24466',
    DarkYellowAlpha20: '#D9B24433',

    LightGold: '#E8D18F',
    Gold: '#E1C169',

    WhiteGray: '#9093AA',
    WhiteGray60: '#9093AA99',
    WhiteGray20: '#9093AA33',
    WhiteGray10: '#9093AA1A',

    BorderGray50: '#F7F8FA',
    DisabledInputColor: '#b5b5b7',
    GrayF2: '#F2F2F2',
    Gray96: '#969696',
    Black24: '#242424',
    DarkBlue: '#1A1A29',
    Blue: '#212738',
    Gray: '#686A79',
    Pink: '#FF2D55',
    Green: '#34C759',
    Black: '#1E1E1E',
    LightBlue: '#008CEA',
    NarcissusYellow: '#DBB400',
    AlphaWhite: '#FFFFFF99',
    Red: '#FA2427',
  },
  fonts: {
    'caption-1': {
      'font-size': '12px',
      'font-weight': 'normal',
      'font-family': 'SF Pro Text, SF Pro Display, sans-serif',
    },
  },
};
